/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Muganza 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Muganza": ["Gashinge", "Mubazi", "Muganza", "Ngara", "Nyabirondo", "Rambyanyana"],
  "Rukore": ["Kanazi", "Karanka", "Nyagisenyi", "Remera", "Rwishywa", "Uwinzira"],
  "Samiyonga": ["Bigugu", "Cyurukore", "Gituntu", "Kigwene", "Mazimeru", "Murambi", "Tangabo"],
  "Uwacyiza": ["Bitaba", "Migendo", "Mukongoro", "Murambya", "Mutovu", "Sekera"]
};